import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'utils/state_manager';

import {ReflagProvider as Provider} from '@reflag/react-sdk';

const FeatureFlagProvider = (props) => {
  const user = props.user;
  const publishableKey = (process.env.REACT_APP_REFLAG_PUBLISHABLE_KEY || '').trim();
  const offline = !publishableKey;
  const context = React.useMemo(() => {
    if (!user?.userRn) return {};

    return {
      user: {
        id: user.userRn,
        name: [user.firstName, user.lastName].filter(Boolean).join(' '),
        email: user.email,
      },
    };
  }, [user?.email, user?.firstName, user?.lastName, user?.userRn]);

  return (
    <Provider
      publishableKey={publishableKey}
      context={context}
      offline={offline}
      fallbackFlags={[]}
      enableTracking={!offline}
      toolbar={false}
    >
      {props.children}
    </Provider>
  );
};

FeatureFlagProvider.propTypes = {
  children: PropTypes.node.isRequired,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(React.memo(FeatureFlagProvider));
